import React from 'react';
import styled from 'styled-components';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import {Icon} from '../../../libs/shared/ui/src/components/icon/icon';
import {ColorDot} from '../../../libs/shared/ui/src/components/utility/colorDot';
import {center} from '../../../libs/shared/ui/src/styles/mixins';
import {useUserTheme} from '../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Style.
 */

const StyledEmptyStateDiv = styled.div`
  ${center()};
  padding: 64px 0;
`;

const StyledIconContainerDiv = styled.div`
  position: relative;
  width: 70px;
  height: 70px;
  ${center()};
  margin-bottom: 10px;
`;

const StyledIcon = styled(Icon)`
  position: absolute;
  transform: scale(1.9);
`;

/*
 * Component.
 */

export const ContactDetailsEmptyState = () => {
  const theme = useUserTheme();

  return (
    <StyledEmptyStateDiv>
      <StyledIconContainerDiv>
        <ColorDot color={theme.greys.shade20} size={70} />
        <StyledIcon name="teammates" color={theme.greys.shade50} />
      </StyledIconContainerDiv>
      <Trans id="contact-details-no-contact">No contact</Trans>
    </StyledEmptyStateDiv>
  );
};
